// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1A4EF","vLegacy":"SelectSecondary_vLegacy__1ycMV","error":"SelectSecondary_error__14w2s","disabled":"SelectSecondary_disabled__2AbFH"};